<template>
  <v-app dark>
    <router-view />
    <privacy-alert-app />
    <loader-dialog-app />
    <alert-app />
    <dialog-pwa />
  </v-app>
</template>

<script>
  import Utils from './plugins/utils'

  export default {
    name: 'App',
    components: {
      PrivacyAlertApp: () => import('@/components/App/PrivacyAlertApp'),
      LoaderDialogApp: () => import('@/components/App/LoaderDialogApp'),
      AlertApp: () => import('@/components/App/AlertApp'),
      DialogPwa: () => import('@/components/App/DialogPwa'),
    },
    mounted () {
      if (!localStorage.getItem('privacyOk')) this.$store.dispatch('setPrivacy', true)
      this.initDate()
      if (this.$mobileDetect.phone()) {
        this.$store.dispatch('setItemsPerPage', -1)
      }
    },
    methods: {
      initDate () {
        const now = new Date()
        const end = Utils.formatDate(now, true)
        const begin = Utils.formatDate(now.setMonth(now.getMonth() - 6))
        const date = {
          begin: begin,
          end: end,
        }
        this.$store.dispatch('setDate', date)
      },
    },
  }
</script>

<style>
#app {
  background-image: url("./assets/background_2.jpg");
  height: 100%!important;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}
#app.theme--light > .v-application--wrap > .view-container {
  background-color: rgba(255, 255, 255, 0.8);
}
#app.theme--dark > .v-application--wrap > .view-container {
  background-color: rgba(39, 39, 39, 0.6);
}
#app.theme--light {
  box-shadow:inset 0 0 0 2000px rgba(255, 255, 255, 0.3);
}
#app.theme--dark {
  box-shadow:inset 0 0 0 2000px rgba(39, 39, 39, 0.4);
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #555;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
